import React from 'react';
import '../css/FranchiseOffers.css';

const FranchiseOffers = () => {
  const leftOffers = [
    { id: 1, type: "red-pill", text: "Diploma Certificate in Computer Course" },
    { id: 2, type: "blue-pill", text: "Certificate that valid for all Government & Private Job" },
    { id: 3, type: "red-pill", text: "Study Materials (Book, Bag, Pen, I-Card) for Students" },
    { id: 4, type: "blue-pill", text: "Institute Management Software (Student Data & Fee Management)" }
  ];

  const rightOffers = [
    { id: 5, type: "red-pill", text: "Website Login For Centre (For Online Work)" },
    { id: 6, type: "blue-pill", text: "Marketing Tips & Growth Strategies Training for your Institution." },
    { id: 7, type: "red-pill", text: "Workshop & Seminar At Routine Basis" },
    { id: 8, type: "blue-pill", text: "Quick Service Resolution Within Hours For Urgent Work." }
  ];

  return (
    <section className="gfi-franchise-section">
      <div className="gfi-franchise-container">
        
        {/* TOP COMPONENT HEADER */}
        <div className="gfi-franchise-header">
          <h2 className="gfi-franchise-title">WHAT WE OFFER IF YOU BECOME OUR FRANCHISE PARTNER</h2>
        </div>

        {/* THREE-COLUMN GRID SYMMETRY LAYOUT */}
        <div className="gfi-franchise-grid-mesh">
          
          {/* LEFT TRACK OFFER CAPSULES */}
          <div className="gfi-franchise-track left-track">
            {leftOffers.map((offer) => (
              <div key={offer.id} className={`gfi-offer-capsule-card ${offer.type}`}>
                <div className="gfi-offer-inner-pill">
                  <p className="gfi-offer-main-text">{offer.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CENTER GRAPHIC FOCUS WHEEL */}
          <div className="gfi-franchise-center-focus">
            <div className="gfi-target-red-ring">
              {/* Pointing business professional avatar presentation vector */}
              <img 
                src="https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=400&auto=format&fit=crop" 
                alt="Franchise Partner Mentor Presentation" 
                className="gfi-center-presenter-avatar"
              />
            </div>
          </div>

          {/* RIGHT TRACK OFFER CAPSULES */}
          <div className="gfi-franchise-track right-track">
            {rightOffers.map((offer) => (
              <div key={offer.id} className={`gfi-offer-capsule-card ${offer.type} invert-pointing`}>
                <div className="gfi-offer-inner-pill">
                  <p className="gfi-offer-main-text">{offer.text}</p>
                </div>
              </div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
};

export default FranchiseOffers;